import { Accordion, Center, Loader } from '@mantine/core';
import { useUnit } from 'effector-react';
import { FolderTree } from 'lucide-react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Device, Player } from 'shared/api';
import { Empty } from 'shared/ui';
import { gamePageModel } from '../../model';
import { GamePageDevice } from '../game-page-device';
import cls from './game-page-accordion.module.scss';

export type GamePageAccordionProps = {
	deviceActionSlot: (device: Device) => ReactNode;
	playerActionSlot: (player: Player) => ReactNode;
};

export const GamePageAccordion = ({
	deviceActionSlot,
	playerActionSlot,
}: GamePageAccordionProps) => {
	const [devices, pending, isEmptyDevices] = useUnit([
		gamePageModel.$devices,
		gamePageModel.$pending,
		gamePageModel.$isEmptyDevices,
	]);

	const { t } = useTranslation('common');

	if (pending)
		return (
			<Center>
				<Loader />
			</Center>
		);

	if (isEmptyDevices)
		return (
			<Empty
				icon={<FolderTree />}
				title={t('game-page.empty-devices.title')}
				message={t('game-page.empty-devices.message')}
			/>
		);

	return (
		<Accordion
			multiple
			classNames={{
				control: cls.gamePageAccordionControl,
			}}
		>
			{devices.map((device) => (
				<GamePageDevice
					key={device.id}
					deviceId={device.id}
					actionSlot={deviceActionSlot}
					playerActionSlot={playerActionSlot}
				/>
			))}
		</Accordion>
	);
};
